<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>严重废规则</el-breadcrumb-item>
		</el-breadcrumb>

		<ToolBar v-on:select="handleSelectJT" :timerVisible="false" />
		<div class="monitor_section" v-if="showDeviceInfo">
			<el-row :gutter="20" type="flex">
				<el-col :span="14">
					<DefectLevelConfig class="grid-content" :file_id="defect_level_fileId" :jt_id="jt_id" />
				</el-col>
				<el-col :span="10">
					<DefectRuleConfig class="grid-content" :file_id="rule_fileId" :jt_id="jt_id" />
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import ToolBar from './ToolBar'
	import DefectLevelConfig from './rule/DefectLevelConfig.vue'
	import DefectRuleConfig from './rule/DefectRuleConfig.vue'
	export default {
		components: {
			ToolBar,
			DefectLevelConfig,
			DefectRuleConfig,
		},
		data() {
			return {
				currentJT: {},
				showDeviceInfo: false,
				defect_level_fileId: '',
				rule_fileId: '',
			}
		},
		computed: {
			jt_id() {
				var jt_id = ''
				if (this.currentJT._id) {
					jt_id = this.currentJT._id.$oid
				}

				return jt_id
			},
		},
		methods: {
			/**
			 * 查看机台状态。
			 */
			handleSelectJT(jtInfo) {
				this.showDeviceInfo = true
				this.currentJT = jtInfo
				//缺陷等级配置文件Id。
				this.defect_level_fileId = jtInfo.statusInfo.defect_level_file_id
				//严重废规则配置文件Id。
				this.rule_fileId = jtInfo.statusInfo.rule_info_file_id

				console.log('查看严重废规则：', jtInfo, this.defect_level_fileId, this.rule_fileId)
			},
		},
		created() {},
	}
</script>

<style lang="less" scoped>
	.grid-content {
		background-color: #f5f5f5;
		padding: 20px;

		/deep/.toolbar {
			text-align: left;
			margin-bottom: 20px;
			border-bottom: 1px #c7c7c7 solid;
			padding-bottom: 20px;
		}

		/deep/.subTitle {
			font-size: 16px;
			font-weight: bold;
			line-height: 32px;
		}
	}

	.slider-item {
		margin-bottom: 10px;
	}

	.slider {
		margin-left: 7px;
		margin-right: 10px;
	}

	.slider {
		/deep/.el-slider__bar {
			background-color: #d4d7dd;
		}

		/deep/.el-slider__button {
			width: 5px;
			height: 16px;
			border: 2px solid #dd0010;
			background-color: #dd0010;
			border-radius: 0;
			transition: 0.2s;
			user-select: none;
		}
	}
</style>
